"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _label = _interopRequireDefault(require("./label.proptypes"));
var _constant = require("./constant");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const getLabelToken = name => _ref => {
  let {
    theme,
    type
  } = _ref;
  const token = {
    [_constant.TOKENS.LABEL_COLOR]: {
      [_constant.LABEL_TYPE.PRIMARY]: theme.colors.primaryLight,
      [_constant.LABEL_TYPE.SECONDARY]: theme.colors.default
    },
    [_constant.TOKENS.TEXT_COLOR]: {
      [_constant.LABEL_TYPE.PRIMARY]: theme.colors.primaryDark,
      [_constant.LABEL_TYPE.SECONDARY]: theme.colors.neutral
    }
  };
  return token[name][type];
};
const LabelContainer = _styledComponents.default.div.withConfig({
  displayName: "Label__LabelContainer",
  componentId: "sc-vavi3d-0"
})(["display:inline-block;box-sizing:border-box;background-color:", ";border-radius:", ";", " ", ";"], _ref2 => {
  let {
    labelColor,
    type,
    theme
  } = _ref2;
  return !Object.values(_constant.LABEL_TYPE).includes(type) && labelColor ? theme.colors[labelColor] : getLabelToken(_constant.TOKENS.LABEL_COLOR);
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.borderRadius.normal;
}, _ref4 => {
  let {
    noTextAlign
  } = _ref4;
  return !noTextAlign && 'align-items: center;';
}, _ref5 => {
  let {
    noPadding,
    theme
  } = _ref5;
  return !noPadding && "padding: 2px ".concat(theme.space.micro);
});
const Text = _styledComponents.default.div.withConfig({
  displayName: "Label__Text",
  componentId: "sc-vavi3d-1"
})(["font-size:", ";line-height:", ";font-weight:", ";color:", ";", ""], _ref6 => {
  let {
    theme,
    size = theme.fontSize.XSmall
  } = _ref6;
  return Object.keys(theme.fontSize).includes(size) ? theme.fontSize[size] : size;
}, _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.space.small;
}, _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.fontWeight.medium;
}, _ref9 => {
  let {
    textColor,
    type,
    theme
  } = _ref9;
  return !Object.values(_constant.LABEL_TYPE).includes(type) && textColor ? theme.colors[textColor] : getLabelToken(_constant.TOKENS.TEXT_COLOR);
}, _ref10 => {
  let {
    noTextAlign
  } = _ref10;
  return !noTextAlign && 'align-items: center;';
});
const limitCharacters = function (value) {
  let limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  if (value && value.length > limit) {
    return "".concat(value.substr(0, limit), "...");
  }
  return value;
};
const Label = props => {
  const {
    children,
    theme,
    type,
    textLimit,
    accessible,
    customProperties,
    textColor,
    labelColor
  } = props;
  const tabIndex = !accessible ? '-1' : '0';
  const themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  const getMain = () => {
    return /*#__PURE__*/_react.default.createElement(LabelContainer, (0, _extends2.default)({
      type: type,
      labelColor: labelColor
    }, customProperties), /*#__PURE__*/_react.default.createElement(Text, (0, _extends2.default)({
      type: type,
      tabIndex: tabIndex,
      accessible: accessible,
      textColor: textColor
    }, customProperties, {
      theme: themeContext
    }), textLimit !== undefined && limitCharacters(children, textLimit) || children));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
Label.propTypes = _label.default.PropTypes;
Label.defaultProps = _label.default.DefaultProps;
var _default = exports.default = Label;